import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  transform: rotate(-5deg);\n  opacity: 0.6;\n'], ['\n  transform: rotate(-5deg);\n  opacity: 0.6;\n']);

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var Box = function Box(_ref) {
  var img = _ref.img,
      alt = _ref.alt,
      className = _ref.className;

  return React.createElement('img', { src: img, alt: alt, className: className });
};

// Box styling when dragging
//  styled(Box) passes className to Box
export var StyledDragLayer_Box = styled(Box)(_templateObject);

Box.propTypes = {
  img: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.any
};

export default memo(Box);